import { Tag, Text, TagProps } from '@cdl/heartbeat-react';

interface Props extends Pick<TagProps, 'colorScheme'> {
  label: string;
  icon: React.ReactNode;
}

export const Status: React.FC<Props> = ({ icon, label, colorScheme }) => (
  <Tag colorScheme={colorScheme} data-testid='save-status' size='sm'>
    {icon}
    <Text fontSize='s' ml='xxs'>
      {label}
    </Text>
  </Tag>
);
